import SidebarUnitDesktop from "../../components/SidebarUnitDesktop";
import {Building} from "../../../../assets/icons";

const CompanyDL = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"company"} 
            routeSidebar={"/company"}
            icon={Building}
            text="Entreprises"
        />
    )
}

export default CompanyDL;